import React from "react";
import {
  TestimonialSection,
  FeaturesSection,
  HeroBanner,
  EcosystemSection,
  CustomerReview,
  GetValue,
} from "./index";
import { Flex } from "theme-ui";

const Home = ({ data }) => {
  return (
    <Flex sx={{ flexDirection: "column" }}>
      <HeroBanner data={data?.heroBanners[0]} />
      <FeaturesSection />
      <GetValue
        moduleSectionHeading={data?.moduleSectionHeading}
        modules={data?.modules}
      />
      <CustomerReview />
      <EcosystemSection
        ecosystemSectionTitle={data?.ecosystemSectionTitle}
        ecosystemSectionImage={data?.ecosystemSectionImage}
        ecosystemSectionDescription={data?.ecosystemSectionDescription}
        ecosystems={data?.ecosystems}
      />
      <TestimonialSection testimonial={data?.nodes[0]} />
    </Flex>
  );
};

export default Home;
